import Styled from "styled-components";

export const Container = Styled.div`
`;

export const ContainerGrid = Styled.div`
  display: grid;
  grid-gap: 10px;
  grid-auto-flow: ${(props) => props.direction || "row"};
  grid-template-columns: 20px 75% 40px;
  margin-bottom: 10px;
`;

export const Label = Styled.h1`
`;
export const Space = Styled.div`
`;

export const EmptyCard = Styled.div`

  #goHomeButton {
    margin-top: 80px;
    margin-bottom: 180px;
  }
`;

export const Trash = Styled.div`
`;

export const Radio = Styled.input`
`;
export const Link = Styled.div`
`;

export const GroupIcons = Styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const TitleProduct = Styled.p`
`;

export const Center = Styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Line = Styled.div`
margin-top: 5px;
margin-bottom: 5px;
border: solid 1px #F0F2F5;
`;

export const Total = Styled.p`
font-weight: 700;
font-style: bold;
font-size: 16px;
line-height: 150%;
color: ${props => props.theme.whitelabel?.theme?.text_primary_color};
letter-spacing: 0%;
`

export const LabelText = Styled.p`
  font-weight: 500;
  font-style: medium;
  font-size: 16px;
  line-height: 150%;
  color: ${props => props.theme.whitelabel?.theme?.text_primary_color};
  letter-spacing: 0%;
`

/* ===== Desktop (>=1024px): carrinho em 2 colunas ===== */
export const CartLayout = Styled.div`
  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 360px;
    gap: 32px;
    align-items: start;
    margin-top: 24px;
    .cart-list .row { align-items: center; }
    .cart-list .col-4 { flex: 0 0 auto; width: auto; max-width: none; }
    .cart-list .col-8 { flex: 1 1 auto; width: auto; max-width: none; }
    .cart-list .img-thumbnail { width: 88px; height: 88px; object-fit: cover; }
  }
`;

export const SummaryCard = Styled.div`
  @media (min-width: 1024px) {
    background: #F5F5F7;
    border-radius: 8px;
    padding: 20px 16px;
    position: sticky;
    top: 100px;

    .cart-actions {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 8px;
    }
  }
`;

/* Desktop: alinha o Container do Bootstrap ao padrão do header (1320/32) */
export const PageWrap = Styled.div`
  padding-bottom: 140px;

  @media (min-width: 1024px) {
    padding-bottom: 0;

    .container {
      max-width: 1320px;
      padding-left: 32px;
      padding-right: 32px;
    }
  }
`;

export const FixedFooter = Styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background: white;
  border-top: 1px solid #d9d9d9;
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  .btn-default-wl,
  .btn-outline-wl {
    width: calc(100% - 24px) !important;
    max-width: calc(100% - 24px);
    margin: 0 auto 8px;
    display: block;
  }

  .btn-outline-wl {
    margin-bottom: 0;
  }

  @media (min-width: 576px) {
    .btn-default-wl,
    .btn-outline-wl {
      max-width: calc(540px - 24px);
    }
  }

  @media (min-width: 768px) {
    .btn-default-wl,
    .btn-outline-wl {
      max-width: calc(720px - 24px);
    }
  }

  @media (min-width: 992px) {
    .btn-default-wl,
    .btn-outline-wl {
      max-width: calc(960px - 24px);
    }
  }

  @media (min-width: 1024px) {
    display: none;
  }
`;

export const CartFinancialSummaryWrap = Styled.div`
  background: #F7F7F7;
  border-radius: 12px;
  padding: 24px;
  margin-top: 24px;
  margin-bottom: 24px;
  width: 100%;
`;

export const CartFinancialSummaryRows = Styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CartFinancialSummaryRow = Styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  line-height: 20px
  color: #5C5C5C;

  .label {
    font-size: 14px;
    font-weight: 600;
  }

  .value {
    font-size: 14px;
    font-weight: 700;
    text-align: right;
  }
`;

export const CartFinancialSummaryDivider = Styled.div`
  height: 1px;
  background: #E2E2E2;
  margin-top: 24px;
  margin-bottom: 12px;
`;

export const CartFinancialSummaryTotalRow = Styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  line-height: 24px;
  color: #2B2B2B;

  .total-label {
    font-size: 14px;
    font-weight: 600;
  }

  .total-value {
    font-size: 16px;
    font-weight: 700;
    text-align: right;
  }
`;